// src/pages/ManageAssessmentSchedule.jsx
import React, { useRef } from "react";
import MasterLayout from "../otherImages/MasterLayout";
import DefaultTopBar from "../components/DefaultTopBar";
import { useDispatch, useSelector } from "react-redux";
import Toast from "../components/Toast";
import AdminAssessmentSchedule from "../components/AdminAssessmentSchedule";

const ManageAdminAssessmentSchedule = () => {
  const dispatch = useDispatch();

  // Create a ref to access AdminAssessmentSchedule methods
  const scheduleRef = useRef();

  // Get states from Redux
  const { 
    isDownloadingCSV, 
    downloadCSVError, 
    successMessage 
  } = useSelector((state) => state.assessmentSchedule || {});

  const handleDownloadCSV = () => {
    // Get the current filter parameters from the AdminAssessmentSchedule component
    if (scheduleRef.current) {
      const filterParams = scheduleRef.current.getFilterParams();
      // You can implement CSV download here if needed in the future
      console.log("Download CSV with params:", filterParams);
    }
  };

  return (
    <>
      {downloadCSVError && (
        <Toast
          show={!!downloadCSVError}
          message={downloadCSVError}
          type="error"
          onClose={() => {
            // Clear error if needed
          }}
          duration={3000}
        />
      )}

      {successMessage && (
        <Toast
          show={!!successMessage}
          message={successMessage}
          type="success"
          onClose={() => {
            // Clear success message if needed
          }}
          duration={3000}
        />
      )}

      <MasterLayout>
        <DefaultTopBar
          title="Assessment Schedules"
          // btnText2="Download CSV"
          // btnLink2="#"
          // isApiButton2={true}
          // onBtn2Click={handleDownloadCSV}
          // isBtn2Loading={isDownloadingCSV}
          // btn2LoadingText="Downloading..."
        />

        <AdminAssessmentSchedule ref={scheduleRef} />
      </MasterLayout>
    </>
  );
};

export default ManageAdminAssessmentSchedule;